import { Template7Component } from './fsm/template/template7/template7.component';
import { ReportsVisitsComponent } from './components/reports-visits/reports-visits.component';
import { ReportsLeadsComponent } from './components/reports-leads/reports-leads.component';
import { SharedComponentModule } from './../modules/shared/shared.module';
import { Table2Component } from './table2/table2.component';
import { TableComponent } from './table/table.component';
import { ReportsOpportunityComponent } from './components/reports-opportunity/reports-opportunity.component';
import { DataService } from './dataService';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ContextMenuModule } from 'primeng/contextmenu';
import { PrimngDesignModule } from './../modules/primng-design/primng-design.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GridsterModule } from "angular-gridster2";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { LayoutModule } from "@angular/cdk/layout";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { DashboardTerritoryMapComponent } from '../modules/shared/components/dashboard-territory-map/dashboard-territory-map.component';
import { DashboardFinanceReportsComponent } from './components/dashboard-finance-reports/dashboard-finance-reports.component';
import { DashboardSavedsearchReportsComponent } from './components/dashboard-savedsearch-reports/dashboard-savedsearch-reports.component';
import { DashboardWhatsappReportsComponent } from './components/dashboard-whatsapp-reports/dashboard-whatsapp-reports.component';
import { VisitReportsComponent } from './components/visit-reports/visit-reports.component';
import { TreeModule } from "primeng/tree";
import { TreeTableModule } from "primeng/treetable";
import { TreeSelectModule } from 'primeng/treeselect';
import { BaseChartDirective } from 'ng2-charts';

const sharedComponents = [
    //components
    Template7Component,
    TableComponent,
    Table2Component,
    ReportsOpportunityComponent,
    ReportsLeadsComponent,
    ReportsVisitsComponent,
    VisitReportsComponent,
    DashboardTerritoryMapComponent,
    DashboardFinanceReportsComponent,
    DashboardSavedsearchReportsComponent,
    DashboardWhatsappReportsComponent
];
@NgModule({
    declarations: [...sharedComponents],
    imports: [
        PrimngDesignModule,
        TreeModule,
        TreeTableModule,
        TreeSelectModule,
        FormsModule,
        ReactiveFormsModule,
        GridsterModule,
        LayoutModule,
        DragDropModule,
        FormsModule,
        ReactiveFormsModule,
        ContextMenuModule,
        GridsterModule,
        BaseChartDirective,
        SharedComponentModule
    ],
    providers: [
        ConfirmationService, MessageService, DataService
    ],
    exports: [...sharedComponents, ReactiveFormsModule, FormsModule],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class ReportsSharedModule { }
